<template>
  <div class="screenshots">
    <div class="screenshots-grid" ref="grid">
      <div v-for="src in screenshots" :key="src.id" ref="screenshot" class="screenshot">
        <!-- <div ref="shadow" class="shadow"></div> -->
        <div ref="image" class="image">
          <img :src="src" alt>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax, TimelineMax } from "gsap/TweenMax";
// import ScrollMagic from "scrollmagic";
// import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
import { imageApi } from "@/api";

export default {
  props: ["data"],
  data() {
    return {
      tl: null,
      hoverState: false
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowSize.width;
    },
    screenshots() {
      return this.data.map(x => imageApi.getUrl(x.screenshot, { w: 600 }));
    }
  },
  methods: {
    // initScroll() {
    //   this.controller = new ScrollMagic.Controller();
    //   this.tl = new TimelineMax();
    //   const el = this.$refs.grid;
    //   const desktopAnimation = () => {
    //     this.$refs.screenshot.forEach((item, i) => {
    //       this.tl.from(item, 1, { z: `${(i + 1) * 100}%` }, 0);
    //     });
    //     new ScrollMagic.Scene({
    //       triggerElement: el,
    //       triggerHook: "onEnter",
    //       duration: "200%"
    //     })
    //       .setTween(this.tl)
    //       .addTo(this.controller);
    //   };
    //   const mobileAnimation = () => {
    //     this.tl.staggerFrom(
    //       el.children,
    //       0.5,
    //       { y: 30, opacity: 0, ease: Cubic.easeInOut },
    //       0.1
    //     );
    //     new ScrollMagic.Scene({
    //       triggerElement: el,
    //       triggerHook: 0.7,
    //       reverse: false
    //     })
    //       .setTween(this.tl)
    //       .addTo(this.controller);
    //   };
    //   if (this.windowWidth < 768) {
    //     mobileAnimation();
    //   } else {
    //     desktopAnimation();
    //   }
    // },
    // onMouseover(i) {
    //   TweenMax.to(this.$refs.grid.children[i].querySelector(".image"), 0.3, {
    //     y: "-=20",
    //     x: "-=20"
    //   });
    // },
    // onMouseleave(i) {
    //   TweenMax.to(this.$refs.grid.children[i].querySelector(".image"), 0.3, {
    //     y: "0",
    //     x: "0"
    //   });
    // }
  }
  // mounted() {
  //   this.$nextTick(() => {
  //     this.initScroll();
  //   });
  // },
  // beforeDestroy() {
  //   if (this.controller) {
  //     this.controller.destroy(true);
  //     this.controller = null;
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.screenshots {
  position: relative;

  @media (min-width: 768px) {
    padding-top: 15vw;
    padding-bottom: 15vw;
  }
}
.screenshots-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;

  @media (max-width: 767px) {
    justify-items: center;
  }

  @media (min-width: 768px) {
    max-width: 100%;
    transform: rotateX(45deg) rotateZ(45deg) translateX(45%);
    transform-style: preserve-3d;
    transform-origin: top center;

    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem;
  }
  @media (min-width: 1024px) {
    grid-gap: 4rem;
  }
}
.screenshot {
  box-shadow: 5px 5px 30px 0 rgba(black, 0.2);
  // @media (max-width: 767px) {
  //   box-shadow: 5px 5px 30px 0 rgba(black, 0.2);

  //   // margin-left: -25px;
  //   // margin-right: -25px;

  //   // &:nth-child(1) {
  //   //   margin-right: -25px;
  //   // }
  //   // &:nth-child(2) {
  //   //   margin-left: -25px;
  //   // }

  //   .shadow {
  //     display: none;
  //   }
  // }

  .image {
    padding-bottom: 100%;
  }

  img {
    width: 100%;
    // height: auto;
    display: block;
  }

  @media (min-width: 768px) {
    flex: 0 0 50%;
    grid-row: span 1;
    transform-style: preserve-3d;

    // &:nth-child(1) {
    //   // grid-row: span 2;
    //   transform: translateZ(-10%);

    //   .image {
    //     padding-bottom: 112.5%;
    //   }
    // }

    .image {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: white;
      overflow: hidden;

      img {
        position: absolute;
        width: 100%;
        object-fit: cover;
        object-position: 0 0;
        backface-visibility: hidden;
      }
    }
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: white;
      box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
      pointer-events: none;
      backface-visibility: hidden;
    }
  }
}
</style>
